<template>
  <div class="eda-premium-pre-sale-card" @click="updateSelectedPlan(plan)">
    <div class="eda-premium-pre-sale-card__radio-button">
      <RadioButton :isSelected="isSelected" />
    </div>
    <div class="eda-premium-pre-sale-card__title">Enterprise Defense Administrator</div>
    <div class="eda-premium-pre-sale-card__promo-info">
      <Pill info> + 3 months of Premium* </Pill>
    </div>
    <div class="eda-premium-pre-sale-card__price">
      {{ `$${price}` }}
      <span class="eda-premium-pre-sale-card__price-term">
        *After 3 months, you'll be billed $350 for 9 more months of Premium. Your subscription
        renews annually at $749.
      </span>
    </div>
    <div class="eda-premium-pre-sale-card__details">
      <PlanListItemDetails :plan="plan" />
    </div>
    <div class="eda-premium-pre-sale-card__best-value">
      Buy on Pre-Sale and &nbsp;<strong>Save $200</strong>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PlanListItemDetails from '@/components/plan-item-card/PlanListItemDetails.vue'
import CONSTANTS from '@/constants'
import RadioButton from '@/components/shared/RadioButton.vue'
import Pill from '@/components/shared/Pill.vue'

export default {
  name: 'PlanRowItemEDAPremiumCard',
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  components: {
    PlanListItemDetails,
    RadioButton,
    Pill,
  },
  methods: {
    updateSelectedPlan(plan) {
      this.$emit('update-selected-plan', plan)
    },
  },
  computed: {
    ...mapState({
      shoppingCart: state => state.shoppingCart.shoppingCart,
    }),
    isSelected() {
      const selected = this.shoppingCart.find(
        plan => plan.merchant_id === CONSTANTS.PLANS.EDA_PREMIUM
      )
      return !!selected
    },
    price() {
      return this.plan.price_cents / 100
    },
  },
}
</script>

<style lang="scss" scoped>
.eda-premium-pre-sale-card {
  background: var(--mid-gray-gradient);
  border-radius: 10px;
  padding: 20px 40px;
  position: relative;
  cursor: pointer;
  transition: all 1s ease-out;
  &:hover {
    background: var(--mid-gray-translucid-gradient);
  }
  &:active {
    transition: all 0.5s ease-out;
    background: var(--charcoal-gradient-two);
  }
  &__title {
    font-weight: 700;
    font-size: rem(24px);
    line-height: 32px;
    display: flex;
    align-items: center;
    &-img {
      margin-left: 5px;
    }
  }
  &__promo-info {
    padding: 15px 0;
  }
  &__price {
    font-weight: 700;
    font-size: rem(54px);
    line-height: 66px;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid var(--mid-gray-translucid);
    @include mobile {
      padding-bottom: 40px;
      margin-bottom: 40px;
    }
    &-term {
      font-weight: 450;
      font-size: rem(12px);
      line-height: 14px;
      margin-left: 20px;
    }
  }
  &__details {
    margin-bottom: 15px;
    padding-bottom: 40px;
  }
  &__best-value {
    background: var(--purple-gradient);
    position: absolute;
    width: 100%;
    float: left;
    bottom: 0;
    left: 0;
    border-radius: 0 0 10px 10px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 450;
    font-size: rem(12px);
    line-height: 14px;
  }
  &__radio-button {
    position: relative;
    left: 20px;
  }
}
</style>
